export default {
  development: {
    // api: "http://192.168.0.178:3001",
    // api: "https://cardapiodigital.beachpark.com.br/api",
    // api: "https://angraboutiquehotel.be2back.com.br:10445/api",
    api: "http://pdv.travelxs.com.br/api2",

    theme: {
      dark: false,
      themes: {
        light: {
          primary: "#21232E",
          secondary: "#2360A1",
          accent: "#3F6EC0",
          error: "#8B2526",
          info: "#215696",
          success: "#37713B",
          warning: "#BC8413",
          bar: "#15161E",
        },
      },
    },
  },
  production: {
    //api: "https://cardapiodigital.beachpark.com.br/api", //beachpark
    //api: "http://192.168.1.200/api", // hotel_1948
    //api: "http://cardapiodigital.ecoporanhotel.com:2017/api/", // ecoporan
    //api: "https://itacaresuites.be2back.com.br:10442/api/", // itacare
    //api: "https://riodaspedras.be2back.com.br:10441/api", // riodaspedras
    // api: "https://pdv.travelxs.com.br/api2",
    // api: "https://angraboutiquehotel.be2back.com.br:10445/api",
    //  api: "https://restauranteequinocios.be2back.com.br:10449/api",
    // api: "https://barretospark.be2back.com.br:10550/api",
    // api: "https://goldeningahotel.be2back.com.br:10448/api",
    // api: "https://vilacaracol.be2back.com.br:10553/api",
    //  api: "https://hotelchalelagoadosingas.be2back.com.br:10551/api",
    api: "/api",
    theme: {
      dark: false,
      themes: {
        light: {
          primary: "#21232E",
          secondary: "#2360A1",
          accent: "#3F6EC0",
          error: "#8B2526",
          info: "#215696",
          success: "#37713B",
          warning: "#BC8413",
          bar: "#15161E",
        },
      },
    },
  } /* production: {
    api: "http://localhost:3000",
    theme: {
      primary: "#5e35b1",
      secondary: "#5d4037",
      accent: "#82B1FF",
      error: "#FF5252",
      info: "#2196F3",
      success: "#4CAF50",
      warning: "#FFC107"
    }
  }*/,
};
